import { FormActionTypes } from './actionTypes';
// Action creators for convenience and type safety
export var createSetStepAction = function (payload) { return ({
    type: FormActionTypes.SET_STEP,
    payload: payload
}); };
export var createSetRegoDetailsAction = function (payload) { return ({
    type: FormActionTypes.SET_REGO_DETAILS,
    payload: payload
}); };
export var createSetVehicleDetailsAction = function (payload) { return ({
    type: FormActionTypes.SET_VEHICLE_DETAILS,
    payload: payload
}); };
export var createSetManualLookupDetailsAction = function (payload) { return ({
    type: FormActionTypes.SET_MANUAL_LOOKUP_DETAILS,
    payload: payload
}); };
export var createSetEntryMethodAction = function (payload) { return ({
    type: FormActionTypes.SET_ENTRY_METHOD,
    payload: payload
}); };
export var createSetExclusionStatusAction = function (payload) { return ({
    type: FormActionTypes.SET_EXCLUSION_STATUS,
    payload: payload
}); };
export var createSetPreviousSessionAction = function (payload) { return ({
    type: FormActionTypes.SET_PREVIOUS_SESSION,
    payload: payload
}); };
export var createResetFormAction = function () { return ({
    type: FormActionTypes.RESET_FORM,
    payload: undefined
}); };
